import CONSTANT from "./constant";
/* === get link image destination === */
export function getImage(image = "", type = "product") {
    if (image) {
        let img = "";
        switch (type) {
            case "location": {
                if (image.indexOf('http') === -1) {
                    img = `${CONSTANT.STATIC_URL}${image}`;
                }
                else {
                    img = image
                }
                break;
            }
            case "post": {
                if (image.indexOf('http') === -1) {
                    img = `${CONSTANT.STATIC_URL}${image}`;
                }
                else {
                    img = image
                }
                break;
            }
            case "product": {
                if (image.indexOf('http') === -1) {
                    img = `${CONSTANT.STATIC_URL}${image}`;
                }
                else {
                    img = image
                }
                break;
            }
            case "doctor": {
                if (image.indexOf('http') === -1) {
                    img = `${CONSTANT.STATIC_URL}${image}`;
                }
                else {
                    img = image
                }
                break;
            }
            case "specialty": {
                if (image.indexOf('http') === -1) {
                    img = `${CONSTANT.STATIC_URL}${image}`;
                }
                else {
                    img = image
                }
                break;
            }
            case "service": {
                if (image.indexOf('http') === -1) {
                    img = `${CONSTANT.STATIC_URL}${image}`;
                }
                else {
                    img = image
                }
                break;
            }
            case "hospital": {
                if (image.indexOf('http') === -1) {
                    img = `${CONSTANT.STATIC_URL}${image}`;
                }
                else {
                    img = image
                }
                break;
            }
            case "insurrance": {
                img = `${CONSTANT.STATIC_URL}${image}`;
                break;
            }
            case "coupon": {
                img = `${CONSTANT.STATIC_URL}${image}`;
                break;
            }
            default: {
                img = ``;
                break;
            }
        }
        return img;
    }
    else
        return `data:image/png;base64,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`;
}
// off auto complete select
export function offAutoCompleteSelect() {
    const el = document.getElementsByClassName("ant-select-selection-search-input");
    for (let i = 0; i < el.length; i++) {
        el[i].setAttribute(
            "autocomplete",
            "registration-select"
        );
    }
}
export function calculateDate(checkin, checkout) {
    let dateCheckin = new Date(checkin);
    let dateCheckout = new Date(checkout);
    // time diff
    let timeDiff = Math.abs(dateCheckout.getTime() - dateCheckin.getTime());
    let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return diffDays;
}
// currency format
export function currencyFormat(num, fixed = 0) {
    return parseFloat(num).toFixed(fixed).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
}
// get currency
export function getCurrency(currency) {
    let arrCurrency = {
        USD: '$', EUR: '€', CHF: 'Fr', CAD: 'C$', KRW: '₩', JPY: '¥', VND: '₫'
    }

    return arrCurrency[`${currency}`] || '₫';
}
export function createDoctorName(
    academic_rank = "",
    degree = "",
    category = "",
    fullname = ""
  ) {
    let doctorName = "";
    if (academic_rank) {
      doctorName = `${academic_rank}.`;
    }
    if (degree) {
      doctorName = `${doctorName}${degree}.`;
    }
    if (category) {
      doctorName = `${doctorName}${category}`;
    }
    if (fullname) doctorName = `${doctorName} ${fullname}`;
    return doctorName;
  }
export function getImageVariant(itemOrder) {
    if (itemOrder) {
        let filename = '';
        if (itemOrder.variant && itemOrder.variant.images && itemOrder.variant.images.length > 0) {
            filename = itemOrder.variant.images[0].filename;
        }
        else {
            if (itemOrder.product.images && itemOrder.product.images.length > 0) {
                filename = itemOrder.product.images[0].filename
            }
            else {
                return `static/images/no-image.jpg`;
            }
        }
        return `${CONSTANT.STATIC_URL}${filename}`;
    }
    else
        return `static/images/no-image.jpg`;
}
/* get day of week */
export function getDayOfWeek(dayOfWeek) {
    if (dayOfWeek) {
      switch (dayOfWeek) {
        case "0":
          return "Chủ nhật";
        case "1":
          return "Thứ 2";
        case "2":
          return "Thứ 3";
        case "3":
          return "Thứ 4";
        case "4":
          return "Thứ 5";
        case "5":
          return "Thứ 6";
        case "6":
          return "Thứ 7";
        default:
          break;
      }
    }
  }